module.exports = __webpack_public_path__ + "static/img/brand-1.2907bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-1.png
// module id = h32a
// module chunks = 0